import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";
import {
  FounderFinanceDashboardData,
  FounderFinanceOperatingCostRow,
  UpsertFounderFinanceOperatingCostInput
} from "./founderFinanceTypes";

export * from "./founderFinanceTypes";

export async function fetchFounderFinanceDashboard(): Promise<FounderFinanceDashboardData> {
  const callable = httpsCallable<Record<string, never>, FounderFinanceDashboardData>(functions, "fetchFounderFinanceDashboard");
  const result = await callable({});
  return result.data;
}

export async function upsertFounderFinanceOperatingCost(input: UpsertFounderFinanceOperatingCostInput): Promise<FounderFinanceOperatingCostRow | null> {
  const callable = httpsCallable<UpsertFounderFinanceOperatingCostInput, { operatingCost: FounderFinanceOperatingCostRow | null }>(
    functions,
    "upsertFounderFinanceOperatingCost"
  );
  const result = await callable(input);
  return result.data.operatingCost;
}
